import { ReplacementRentalCarActions } from "../action/replacementRentalcar-action";

export type ReplacementRentalCarResponse = "Yes" | "No, I’ll end my rental";

type ReplacementRentalCarState = {
  customerResponse: ReplacementRentalCarResponse;
};

const initialState: ReplacementRentalCarState = {
  customerResponse: undefined,
};

export const ReplacementRentalCarReducer = (
  state: ReplacementRentalCarState = initialState,
  action: ReplacementRentalCarActions
): ReplacementRentalCarState => {
  switch (action.type) {
    case "UPDATE_REPLACEMENT_RENTAL_CAR_QUESTIONS":
      return { ...state, customerResponse: action.payload };
    case "REFRESH_REDUCERS":
    case "CLEAR_REPLACEMENT_RENTAL_CAR_QUESTIONS":
      return { ...initialState };
    default:
      return state;
  }
};
